/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef, useMemo } from "react";
import { toast } from "react-toastify";
import "./index.css";

// redux imports
import {
  addStatementDescription,
  downloadAllOwnerStatement,
  getAllOwnerAccStatement,
  ownerAccountsViewAll,
  resetStatementData,
  setOwnerAllAccStatementLoading,
  updateStatementData,
  setEndDate,
  setStartDate,
  resetDateRange,
} from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addMatchConsolidatedStatement,
  getAssociatedConsolidatedStatements,
  removeUnmatchConsolidatedStatement,
  resetConsolidatedAllAccStatementData,
  setGetConsolidatedAllAccStatementLoading,
} from "../../../../redux/features/accounts/remitterAccount/remitterAccount";

// components imports
import PaginationComponent from "../../../../components/_utils/PaginationComponent";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import IfscCodeMapper from "../../../../components/_utils/IfscLogoMapper";
import OwnerAccountPopUp from "../../../../components/Accounts/OwnerAccount/OwnerAccountPopUp";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import { globalTextFormat } from "../../../../utils/globalTextFormat";
import OwnerDetailsPage from "../OwnerAccountDetails";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton";
import PrimaryWithIconButton from "../../../../components/_utils/CommonButtons/PrimaryWithIconButton";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import TEXT from "../../../../utils/globalText";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";
import StatementTopNavComponent from "../../../../components/_utils/CommonTopNav/StatementTopNavComponent";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams";
import RemitAccountViewAllPopup from "../../../../components/Accounts/RemitAccount/RemitAccountViewAllPopup";
import RemitterAccountViewAll from "../../RemitterAccount/RemitterAccountViewAll";
import SecondaryAnimatedButton from "../../../../components/_utils/CommonButtons/SecondaryAnimated";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";

const OwnerAccountConsolidatedBankStatement = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const dropdownOptions = PaginationConfiguration.paginationOptions;

  const id = location?.state?.data;
  const type = location?.state?.type;
  const startDateDetails = location?.state?.startDate;
  const endDateDetails = location?.state?.endDate;
  const ownerIddetails = location?.state?.ownerId;
  const matchFlowType = location?.state?.flow || "";
  const matchId = location?.state?.data || "";
  const remitterName = location?.state?.remName || "";
  const selectedtBank = "";
  const matchCondition =
    matchFlowType === "new_match_txn" ||
    matchFlowType === "remitter_details_match_statement" ||
    matchFlowType === "remitter_edit_match_statement";

  const buttonRef = useRef();
  const scrollTopRef = useRef(null);
  const scrollRef = useRef(null);
  const amtDivRef = useRef(null);
  const selectAccountRef = useRef(null);

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();
  const { searchParam, handleSearchParams } = useCustomSearchParams({
    pageno: GlobalConfiguration.lengthCheckOne,
    pagesize: dropdownOptions[0],
  });

  const {
    ownerAllAccStatementData,
    ownerAllAccStatementLoading,
    ownerAllAccAddDescriptionLoading,
  } = useSelector((state) => state.ownerAllVerification);

  const { getAssociatedConsolidatedData, getAssociatedConsolidatedLoading } =
    useSelector((state) => state.remitterAccount);

  const services = useSelector((state) => state.refreshToken.services);

  const hasMatchPermission = services?.some(
    (service) => service === "AMapping" || service === "Admin",
  );
  const hasUnMatchPermission = services?.some(
    (service) => service === "RMapping" || service === "Admin",
  );

  const hasViewPermission = services?.some(
    (service) => service === "REVAccount" || service === "Admin",
  );

  const defaultAdditionalDetailCol = [
    { colName: "Bank", colWidth: "column-width-sm", flex: 0 },
    {
      colName: "Transaction date and time",
      colWidth: "column-width-md",
      flex: 0,
    },
    { colName: "Value date", colWidth: "column-width-md", flex: 0 },
    {
      colName: "Bank reference number",
      colWidth: "column-width-lg",
      flex: 0,
    },
    { colName: "Narration", colWidth: "column-width-lg", flex: 1 },
    { colName: "Type", colWidth: "column-width-md", flex: 0 },
    { colName: "Amount", colWidth: "column-width-md", flex: 0 },
    { colName: "Debit amount", colWidth: "column-width-md", flex: 0 },
    { colName: "Credit amount", colWidth: "column-width-md", flex: 0 },
    { colName: "Closing balance", colWidth: "column-width-md", flex: 0 },
    { colName: "Account number", colWidth: "column-width-md", flex: 0 },
    { colName: "Name", colWidth: "column-width-md", flex: 0 },
    { colName: "IFSC", colWidth: "column-width-md", flex: 0 },
    { colName: "Statement source", colWidth: "column-width-md", flex: 0 },
    { colName: "Description", colWidth: "column-width-lg", flex: 1 },

    ...(props?.flow !== "rejectStatementdetails"
      ? [
          {
            colName: "Remitter account",
            colWidth: "column-width-lg",
            flex: 1,
          },
        ]
      : []),
  ];

  const convertDate = (dateString) => {
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };

  const defaultStartDate = useMemo(() => {
    return convertDate(new Date(new Date().setDate(1)));
  }, []);

  const defaultEndDate = useMemo(() => {
    return convertDate(new Date());
  }, []);

  const [additionalDetailColState, setAdditionalDetailsColState] = useState(
    defaultAdditionalDetailCol,
  );
  const [flowType, setFlowType] = useState(location?.state?.flow || "");
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [remType, setRemType] = useState("");
  const [alertPopup, setAlertPopup] = useState(false);
  const [pendingNavTarget, setPendingNavTarget] = useState(null);

  const [matchLoader, setMatchLoader] = useState(false);
  const [remiAcoountId, setRemiAcoountId] = useState(id || []);

  const [unmatchLoader, setUnmatchLoader] = useState(false);
  const [selectedBankStatement, setSelectedBankStatement] = useState(
    location?.state?.statementid || [],
  );
  const [selectStatementType, setSelectStatementType] = useState(
    location?.state?.flow || "",
  );
  const [selectStatementRow, setSelectStatementRow] = useState([]);
  const [totalRemiAccount, setTotalRemiAccount] = useState([]);
  const [unmatchRemiId, setUnmatchRemiId] = useState([]);
  const [matchRemiId, setMatchRemiId] = useState([]);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [openMatchPopup, setOpenMatchPopup] = useState(false);
  const [showRemiAccounts, setShowRemiAccounts] = useState(false);
  const [openDateFilter, setopenDateFilter] = useState(false);
  const [matchButton, setMatchButton] = useState(
    (selectStatementType === "remitter_details_match_statement" ||
      selectStatementType === "remitter_edit_match_statement" ||
      flowType === "new_match_txn") &&
      ownerAllAccStatementData?.statement?.length >
        GlobalConfiguration.lengthCheckZero
      ? true
      : false,
  );
  const [selectedCardIds, setSelectedCardIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingData, setLoadingData] = useState(false);
  const [unmatchStatement, setUnMatchStatement] = useState("");
  const [matchStatement, setMatchStatement] = useState("");
  const [active, setActive] = useState("");
  const [showOwnerPopup, setShowOwnerPopup] = useState(false);
  const [showOwnerDetailPopup, setShowOwnerDetailPopup] = useState(false);
  const [ownerDetailId, setOwnerDetailID] = useState("");
  const [showAmtFilterDiv, setShowAmtFilterDiv] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAmtFilterApplied, setIsAmtFilterApplied] = useState(false);
  const [isDateConfirm, setIsDateConfirm] = useState(false);
  const [pageSize, setPageSize] = useState(dropdownOptions[0]);
  const [selectedValue, setSelectedValue] = useState(dropdownOptions[0]);
  const [debiteAmount, setDebitAmount] = useState("");
  const [creditAmount, setCreditAmount] = useState("");
  const [selectedtBankState, setSelectedtBankState] = useState("");
  const [amountRangeFilter, setAmountRangeFilter] = useState({
    min:
      props?.flow === "rejectStatementdetails"
        ? ""
        : searchParam.get("min_amount") || "",
    max:
      props?.flow === "rejectStatementdetails"
        ? ""
        : searchParam.get("max_amount") || "",
  });
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showDescriptionPopup, setShowDescriptionPopup] = useState(false);
  const [description, setDescription] = useState("");
  const [currentDescription, setCurrentDescription] = useState({});
  const [isFocused, setIsFocused] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [sourceState, setSourceState] = useState("");
  const [statementTypeState, setStatementTypeState] = useState("");
  const [accountnumberstate, setaccountnumberstate] = useState(
    ownerIddetails
      ? [ownerIddetails]
      : props?.flow === "rejectStatementdetails"
        ? []
        : props?.popType === "ownerStatement" ||
            props?.popType === "remitterBankStatement"
          ? [props?.ownerDetailId]
          : [],
  );
  const [accountNumber, setAccountNumber] = useState(
    ownerIddetails
      ? location?.state?.type === "consolidatedFullView"
        ? [ownerIddetails]
        : ownerIddetails
      : props?.popType === "ownerStatement" ||
          props?.popType === "remitterBankStatement"
        ? [props?.ownerDetailId]
        : [],
  );
  const [accountDefaultNumber, setDefaultAccountNumber] = useState(
    ownerIddetails
      ? [ownerIddetails]
      : props?.popType === "ownerStatement" ||
          props?.popType === "remitterBankStatement"
        ? [props?.ownerDetailId]
        : [],
  );
  const [selectedType, setSelectedType] = useState("XLSX");

  const [isEditDescription, setIsEditDescription] = useState(false);
  const [startDateState, setStartDateState] = useState(
    startDateDetails ||
      (props?.flow === "rejectStatementdetails" ? "" : defaultStartDate),
  );

  const [endDateState, setEndDateState] = useState(
    endDateDetails ||
      (props?.flow === "rejectStatementdetails" ? "" : defaultEndDate),
  );

  const isDateCustom = useMemo(() => {
    if (props?.flow === "rejectStatementdetails") {
      return Boolean(startDateState || endDateState);
    }
    return (
      isDateConfirm &&
      (Number(startDateState) !== Number(defaultStartDate) ||
        Number(endDateState) !== Number(defaultEndDate))
    );
  }, [
    startDateState,
    endDateState,
    defaultStartDate,
    defaultEndDate,
    isDateConfirm,
    props?.flow,
  ]);

  const condition =
    isDateCustom ||
    selectedtBankState.length > GlobalConfiguration.lengthCheckZero ||
    matchStatement !== "" ||
    unmatchStatement !== "" ||
    debiteAmount !== "" ||
    creditAmount !== "" ||
    sourceState?.length > GlobalConfiguration?.lengthCheckZero ||
    statementTypeState?.length > GlobalConfiguration?.lengthCheckZero ||
    (amountRangeFilter.min.length > GlobalConfiguration.lengthCheckZero &&
      amountRangeFilter.max.length > GlobalConfiguration.lengthCheckZero);

  const calenderMaxDate = useMemo(() => new Date(), []);

  const formatAmount = (value) => {
    if (!value) return "";

    return `INR ${Number(value.replace(/,/g, "")).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const statements =
    type === TEXT?.REMITTER_DETAILS || props?.flow === "rejectStatementdetails"
      ? getAssociatedConsolidatedData?.statement
      : ownerAllAccStatementData?.statement;

  const visibleRowIds =
    statements?.map(
      (item, index) =>
        item?.account_statement_entry_id ||
        item?.id ||
        `${currentPage}-${index}`,
    ) || [];

  const currentPageSelectableIds = visibleRowIds.filter(
    (id) => !selectedBankStatement?.includes(id),
  );

  const currentPageSelectedIds = currentPageSelectableIds.filter((id) =>
    selectStatementRow.includes(id),
  );

  const currentPageSelectedCount = currentPageSelectedIds.length;

  const totalUserSelectedCount = selectStatementRow.filter(
    (id) => !selectedBankStatement?.includes(id),
  ).length;

  const remainingSelection = Math.max(
    Number(pageSize) - totalUserSelectedCount,
    0,
  );

  const hasSelectionOutsideCurrentPage =
    currentPageSelectedCount === GlobalConfiguration.lengthCheckZero &&
    selectStatementRow.some(
      (id) =>
        !selectedBankStatement?.includes(id) &&
        !currentPageSelectableIds.includes(id),
    );

  const shouldClearPreviousSelection =
    hasSelectionOutsideCurrentPage &&
    remainingSelection === GlobalConfiguration.lengthCheckZero;

  const totalSelectedCount = totalUserSelectedCount;

  const totalRecordCount = Number(
    (type === TEXT?.REMITTER_DETAILS || props?.flow === "rejectStatementdetails"
      ? getAssociatedConsolidatedData?.total_count
      : ownerAllAccStatementData?.total_count) ||
      GlobalConfiguration?.lengthCheckZero,
  );

  const effectiveSelectCap = Math.min(totalRecordCount, Number(pageSize));

  const isAllVisibleSelected =
    totalSelectedCount === effectiveSelectCap &&
    effectiveSelectCap > GlobalConfiguration?.lengthCheckZero;

  const columnMapper = {
    "Transaction date and time": "Date and Time",
    "Value date": "Value Date",
    "Bank reference number": "Bank Reference No.",
    "Narration": "Narration",
    "Type": "Type",
    "Amount": "Amount",
    "Debit amount": "Debit Amount",
    "Credit amount": "Credit Amount",
    "Bank": "Bank Name",
    "Account number": "Account Number",
    "IFSC": "IFSC Code",
    "Closing balance": "Closing Balance",
    "Statement source": "Statement Source",
    "Description": "Description",
    "Remitter account": "Remmiter Name",
  };

  const handleSubmit = (key, value) => {
    handleSearchParams(key, value);
  };

  const handleFetch = async () => {
    setLoading(true);

    try {
      if (
        type === TEXT?.REMITTER_DETAILS ||
        props?.flow === "rejectStatementdetails"
      ) {
        await dispatch(
          getAssociatedConsolidatedStatements({
            page_no: currentPage,
            page_size: pageSize,
            remitter_account_id: props?.remitter_account_id || "",
            statement_entry_id: props?.statement_entry_id
              ? [props?.statement_entry_id]
              : [],
            min_amount: isAmtFilterApplied ? amountRangeFilter.min : "",
            max_amount: isAmtFilterApplied ? amountRangeFilter.max : "",
            start_date: startDateState,
            end_date: endDateState,
            credit_amount: creditAmount || "",
          }),
        ).unwrap();
      } else {
        await dispatch(
          getAllOwnerAccStatement({
            id: accountNumber?.map((itm) => (itm?.id ? itm.id : itm)),
            start_date: formatDate(startDateState),
            end_date: formatDate(endDateState),
            page_no: currentPage,
            sort_by:
              matchStatement === TEXT?.MATCHED
                ? "mapped"
                : unmatchStatement === TEXT?.UNMATCHED
                  ? "unmapped"
                  : "",
            credit_debit: statementTypeState,
            start_amount: isAmtFilterApplied ? amountRangeFilter.min : "",
            end_amount: isAmtFilterApplied ? amountRangeFilter.max : "",
            credit_amount: creditAmount || "",
            debit_amount: debiteAmount || "",
            page_size: pageSize,
            entry_source: sourceState.length
              ? sourceState === TEXT?.UPLOADED_MANUALLY
              : undefined,
            bank_name: selectedtBank.length ? selectedtBank : undefined,
          }),
        ).unwrap();
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/owner_account_dashboard/consolidated_bank_statement/`,
      state: {
        startDate: startDateState,
        endDate: endDateState,
        ownerId: accountNumber,
      },
    });
  };

  const downloadStatement = async () => {
    UniversalRefreshToast("Downloading statement.");
    setIsDisabled(true);
    try {
      const response = await dispatch(
        downloadAllOwnerStatement({
          id: accountNumber,
          start_date: formatDate(startDateState),
          end_date: formatDate(endDateState),
          credit_debit: statementTypeState,
          start_amount: isAmtFilterApplied ? amountRangeFilter.min : "",
          end_amount: isAmtFilterApplied ? amountRangeFilter.max : "",
          page_size: pageSize,
          formatType: selectedType.toLowerCase(),
          bank_name: selectedtBank.length ? selectedtBank : undefined,
          entry_source: sourceState.length
            ? sourceState === TEXT?.UPLOADED_MANUALLY
              ? true
              : false
            : undefined,
          filter_columns: additionalDetailColState.map(
            (itm) => columnMapper[itm.colName],
          ),
        }),
      );
      toast.dismiss();
      CommonToast({
        text: TEXT?.DOWNLOAD_STATEMENT_SUCCESS,
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      setIsDisabled(false);
      if (!response?.payload?.ok) {
        CommonToast({
          text: response?.payload?.message,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      toast.dismiss();
      CommonToast({
        text: TEXT?.DOWNLOAD_STATEMENT_FAILED,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setIsDisabled(false);
      console.error(error);
    }
  };

  const move = () => {
    scrollRef?.current?.scrollTo({ left: 0, behavior: "smooth" });
    setTimeout(() => {
      scrollTopRef?.current?.scrollTo({ top: 0, behavior: "smooth" });
    }, IntervalConfiguration.intervalExtraSmall);
  };

  const handleSelect = (value) => {
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    setSelectedValue(value);
    setPageSize(value);

    if (Number(value) < Number(pageSize)) {
      const statements =
        type === TEXT?.REMITTER_DETAILS ||
        props?.flow === "rejectStatementdetails"
          ? getAssociatedConsolidatedData?.statement
          : ownerAllAccStatementData?.statement;

      const visibleIds =
        statements
          ?.slice(0, Number(value))
          ?.map(
            (item, index) =>
              item?.account_statement_entry_id || item?.id || `1-${index}`,
          ) || [];

      setSelectStatementRow((prev) =>
        prev.filter(
          (id) =>
            selectedBankStatement?.includes(id) || visibleIds.includes(id),
        ),
      );
    }
  };

  const handlePagination = (page) => {
    if (scrollRef?.current) {
      scrollRef.current.scrollLeft = GlobalConfiguration.lengthCheckZero;
    }
    setCurrentPage(page);
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === GlobalConfiguration?.lengthCheckZero)
      return TEXT?.DEFAULT_SMALL;

    if (length >= GlobalConfiguration?.lengthCheckZero) {
      return "verified";
    }

    return focused ? TEXT?.TYPING : TEXT?.ERROR;
  };

  const handleMatchStatement = async (matchid) => {
    setMatchLoader(true);
    UniversalRefreshToast(
      flowType === "new_match_txn" ||
        flowType === "remitter_details_match_statement" ||
        selectStatementType === "remitter_edit_match_statement"
        ? TEXT?.MATCHING_SELECTED_ACCOUNT
        : TEXT?.MATCHING_REMITTER,
    );

    try {
      const data = await dispatch(
        addMatchConsolidatedStatement({
          remitter_accounts_ids: Array.isArray(matchid) ? matchid : [matchid],
          mapping_ids: Array.isArray(selectStatementRow)
            ? selectStatementRow
            : [selectStatementRow],
        }),
      );

      if (data?.payload?.status === true) {
        toast.dismiss();
        CommonToast({
          text:
            flowType === "new_match_txn" ||
            flowType === "remitter_details_match_statement" ||
            selectStatementType === "remitter_edit_match_statement"
              ? `${
                  selectStatementRow?.length ===
                  GlobalConfiguration.lengthCheckOne
                    ? "Transaction"
                    : "Transactions"
                } matched to the selected ${matchCondition ? TEXT?.ACCOUNT : TEXT?.ACCOUNTS?.toLowerCase()} successfully.`
              : TEXT?.REMITTER_MATCH_SUCCESS,
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });
        if (remiAcoountId?.length > GlobalConfiguration.lengthCheckZero) {
          navigate(
            `/remitter_account_dashboard/remitter_account_view_all/remitter_account_detail_page/${remiAcoountId}`,
            {
              state: {
                flow: "match_transaction",
              },
            },
          );
        } else {
          setOpenMatchPopup(false);
          setShowRemiAccounts(false);
          handleFetch();
          setSelectedCardIds([]);
          setMatchButton(false);
          setSelectStatementRow([]);
          setRemType("");
        }
      } else {
        CommonToast({
          text:
            data?.payload?.message ||
            data?.payload?.errors?.base?.[0] ||
            "Failed to match transactions.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setMatchLoader(false);
      }
    } catch (error) {
      CommonToast({
        text: TEXT?.SOMETHING_WENT_WRONG,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    setOpenMatchPopup(false);
    setMatchLoader(false);
  };

  const handleUnMatchStatement = async (matchid) => {
    setUnmatchLoader(true);
    UniversalRefreshToast(TEXT?.UNMATCHING_REMITTER);

    try {
      let data = await dispatch(
        removeUnmatchConsolidatedStatement({
          remitter_accounts_ids: matchid,
          mapping_ids: Array.isArray(selectStatementRow)
            ? selectStatementRow
            : [selectStatementRow],
        }),
      );

      if (data?.payload?.status === true) {
        toast.dismiss();
        CommonToast({
          text: TEXT?.REMITTER_UNMATCH_SUCCESS,
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          buttonNeeded: false,
        });

        setShowRemiAccounts(false);
        setSelectStatementRow([]);
        setUnmatchRemiId([]);
        handleFetch();
        setSelectedCardIds([]);
        setRemType("");
      } else {
        CommonToast({
          text:
            data?.payload?.message ||
            data?.payload?.errors?.base?.[0] ||
            "Failed to unmatch transactions.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setSelectStatementRow([]);
        setUnmatchRemiId([]);
        setUnmatchLoader(false);
      }
    } catch (error) {
      CommonToast({
        text: TEXT?.SOMETHING_WENT_WRONG,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
    setOpenMatchPopup(false);
    setUnmatchLoader(false);
  };

  const handleAddDetail = (name) => {
    if (!additionalDetailColState.some((x) => x.colName === name)) {
      let data = {
        colName: name,
        colWidth: defaultAdditionalDetailCol.find((x) => x.colName === name)
          ?.colWidth,
        flex: defaultAdditionalDetailCol.find((x) => x.colName === name)?.flex,
      };
      let arr = [...additionalDetailColState, data].sort(
        (a, b) =>
          defaultAdditionalDetailCol.map((x) => x.colName).indexOf(a.colName) -
          defaultAdditionalDetailCol.map((x) => x.colName).indexOf(b.colName),
      );
      setAdditionalDetailsColState(arr);
    } else {
      if (
        additionalDetailColState.length === GlobalConfiguration?.lengthCheckOne
      ) {
        return CommonToast({
          text: TEXT?.COLUMN_REQUIREMENT,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      setAdditionalDetailsColState(
        additionalDetailColState
          .filter((itm) => {
            return name !== itm.colName;
          })
          .sort(
            (a, b) =>
              defaultAdditionalDetailCol
                .map((x) => x.colName)
                .indexOf(a.colName) -
              defaultAdditionalDetailCol
                .map((x) => x.colName)
                .indexOf(b.colName),
          ),
      );
    }
  };

  const formatDateandTime = (date, showtime) => {
    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds =
      date?.getUTCSeconds() || GlobalConfiguration?.lengthCheckZero;

    const ampm = hours >= 12 ? "pm" : "am";
    hours %= 12;
    hours = hours || 12;
    let todayDate = date.getUTCDate();
    let month = date.getUTCMonth() + GlobalConfiguration?.lengthCheckOne;

    if (showtime) {
      return `${todayDate < 10 ? "0" + todayDate : todayDate}-${month < 10 ? "0" + month : month}-${date.getUTCFullYear()}, ${
        hours < GlobalConfiguration.panLength ? "0" + hours : hours
      }:${minutes < GlobalConfiguration.panLength ? "0" + minutes : minutes}:${seconds < 10 ? "0" + seconds : seconds} ${ampm}`;
    } else {
      return `${todayDate < 10 ? "0" + todayDate : todayDate}-${month < 10 ? "0" + month : month}-${date.getUTCFullYear()}`;
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(Number(date) * IntervalConfiguration.intervalMedium);
    if (isNaN(d.getTime())) return "";
    const day = d.getDate();
    const month = d.toLocaleString("en-GB", { month: "short" });
    const year = d.getFullYear();

    return `${day} ${month} ${year}`;
  };

  const handleAmtFilterApply = () => {
    setIsAmtFilterApplied(true);
    setTimeout(() => {
      setShowAmtFilterDiv(false);
    }, 500);
  };

  const handleDateChange = (date) => {
    if (Array.isArray(date) && date[0] && date[1]) {
      const [start, end] = date;
      const startTs = convertDate(start);
      const endTs = convertDate(end);

      setStartDateState(startTs);
      setEndDateState(endTs);
      setIsDateConfirm(true);

      if (props?.popType === "remitterBankStatement") {
        dispatch(setStartDate(startTs));
        dispatch(setEndDate(endTs));
      }
      handleSearchParams("date", `${startTs},${endTs}`);
    } else {
      setStartDateState(defaultStartDate);
      setEndDateState(defaultEndDate);
      handleSearchParams("date", "");
    }
  };

  const handleLeaveConfirm = () => {
    setAlertPopup(false);
    setShowRemiAccounts(false);
    if (pendingNavTarget) {
      navigate(pendingNavTarget);
    }
    setPendingNavTarget(null);
  };

  const handleAlertCancel = () => {
    setAlertPopup(false);
    setPendingNavTarget(null);
  };

  const handleCardNavigate = (targetPath) => {
    setPendingNavTarget(targetPath);
    setAlertPopup(true);
  };

  useEffect(() => {
    return () => {
      if (props?.flow !== "remitterBankStatement") {
        dispatch(resetDateRange());
      }
    };
  }, []);

  const handleKey = (event) => {
    if (showAmtFilterDiv) {
      if (event.key === "Enter" && showAmtFilterDiv && isAmtFilterApplied) {
        handleAmtFilterApply();
      }
    }
  };

  useEffect(() => {
    if (accountNumber.length) {
      handleFetch();
    } else {
      if (
        type === TEXT?.REMITTER_DETAILS ||
        props?.flow === "rejectStatementdetails"
      ) {
        dispatch(setGetConsolidatedAllAccStatementLoading(false));
      } else {
        dispatch(setOwnerAllAccStatementLoading(false));
      }
    }

    return () => {
      if (
        type === TEXT?.REMITTER_DETAILS ||
        props?.flow === "rejectStatementdetails"
      ) {
        dispatch(resetConsolidatedAllAccStatementData());
      }
    };
  }, [
    currentPage,
    statementTypeState,
    pageSize,
    accountNumber,
    selectedtBank,
    startDateState,
    endDateState,
    amountRangeFilter,
    sourceState,
    matchStatement,
    creditAmount,
    unmatchStatement,
    debiteAmount,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(ownerAccountsViewAll({}));
      } catch (error) {
        console.error("Failed to fetch owner accounts:", error);
      }
    };

    fetchData();

    return () => {
      dispatch(resetStatementData());
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (
        type === TEXT?.REMITTER_DETAILS ||
        props?.flow === "rejectStatementdetails"
      ) {
        const itemisedResponse = await dispatch(
          getAssociatedConsolidatedStatements({
            remitter_account_id: remiAcoountId,
            page_no: currentPage,
            page_size: pageSize,
          }),
        );

        if (
          getAssociatedConsolidatedStatements.fulfilled.match(itemisedResponse)
        ) {
          const statementIds =
            itemisedResponse?.payload?.statement
              ?.map((data) => data?.account_statement_entry_id)
              ?.filter(Boolean) || [];

          setSelectedBankStatement(statementIds);
        }
      }
    };

    if (matchCondition) {
      fetchData();
    }
  }, [remiAcoountId, currentPage, pageSize]);

  useEffect(() => {
    const statements =
      type === TEXT?.REMITTER_DETAILS ||
      props?.flow === "rejectStatementdetails"
        ? getAssociatedConsolidatedData?.statement
        : ownerAllAccStatementData?.statement;

    const currentVisibleIds =
      statements?.map(
        (item, index) =>
          item?.account_statement_entry_id ||
          item?.id ||
          `${currentPage}-${index}`,
      ) || [];

    setSelectStatementRow((prev) =>
      prev.filter(
        (id) =>
          selectedBankStatement?.includes(id) || currentVisibleIds.includes(id),
      ),
    );
  }, [pageSize]);

  useEffect(() => {
    if (
      (selectStatementType === "remitter_details_match_statement" ||
        selectStatementType === "remitter_edit_match_statement" ||
        flowType === "new_match_txn") &&
      ownerAllAccStatementData?.statement?.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      setMatchButton(true);
      setStatementTypeState(TEXT?.CREDIT);
    }
  }, [
    selectStatementType,
    flowType,
    ownerAllAccStatementData?.statement?.length,
  ]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (amtDivRef.current && amtDivRef.current.contains(e.target)) {
      } else {
        setShowAmtFilterDiv(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [amtDivRef]);

  useEffect(() => {
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("keydown", handleKey);
    };
  }, [isAmtFilterApplied, showAmtFilterDiv]);

  useEffect(() => {
    if (!pageSize) return;

    const visibleRowIds =
      type !== TEXT?.REMITTER_DETAILS
        ? ownerAllAccStatementData?.statement?.map(
            (item, index) =>
              item?.account_statement_entry_id ||
              item?.id ||
              `${currentPage}-${index}`,
          ) || []
        : getAssociatedConsolidatedData?.statement?.map(
            (item, index) =>
              item?.account_statement_entry_id ||
              item?.id ||
              `${currentPage}-${index}`,
          ) || [];

    setSelectStatementRow((prev) =>
      prev.filter(
        (id) =>
          selectedBankStatement?.includes(id) || visibleRowIds.includes(id),
      ),
    );
  }, [pageSize]);

  return (
    <>
      {<>{RestrictedActionPopup}</>}
      {alertPopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle={TEXT?.LEAVE_PAGE_WARNING_HEADER}
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext={TEXT?.LEAVING_PAGE_WILL_EXIT_FROM_CURRENT_FLOW}
            btnOneText={TEXT?.STAY}
            btnOneHandleFunction={handleAlertCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption={TEXT?.WHITE}
            btnTwoText={TEXT?.LEAVE}
            btnTwoHandleFunction={handleLeaveConfirm}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption={TEXT?.BLACK}
          />
        </div>
      )}

      {showRemiAccounts && (
        <>
          <div className="fixed z-z-index-modal flex items-center justify-center top-left-base left-left-base w-width-full h-height-full  bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle={
                remType === "remitterUnmatch"
                  ? "Unmatch remitter accounts"
                  : remType === "remitterMatch"
                    ? TEXT?.MATCH_REMITTER_ACCOUNTS
                    : TEXT?.REMITTER_ACCOUNTS
              }
              headersubtext={
                remType === "remitterUnmatch"
                  ? TEXT?.ONLY_MATCHED_ACCOUNTS_SELECTION_NOTE
                  : remType === "remitterMatch"
                    ? TEXT?.ONLY_UNMATCHED_ACCOUNT_SELECTION_NOTE
                    : TEXT?.ALL_ACCOUNTS_MATCHED
              }
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={() => {
                if (!matchButton) {
                  setMatchRemiId("");
                  setSelectedCardIds([]);
                  setSelectStatementRow([]);
                }
                setTotalRemiAccount("");
                setUnmatchRemiId("");
                setRemType("");
                setShowRemiAccounts(false);
              }}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption={TEXT?.WHITE}
              closeiconbtnType={TEXT?.BUTTON}
              closeiconisDisabled={false}
              smallpopupsubtext={TEXT?.LEAVING_PAGE_WILL_EXIT_FROM_CURRENT_FLOW}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={TEXT?.CLOSE}
              btnType={
                remType === "remitterUnmatch"
                  ? TEXT?.UNMATCH
                  : remType === "remitterMatch"
                    ? TEXT?.MATCH
                    : TEXT?.CONFIRM
              }
              handleFunction={() => {
                if (remType === "remitterUnmatch") {
                  if (
                    selectedCardIds?.length >
                    GlobalConfiguration.lengthCheckZero
                  ) {
                    if (
                      services?.find(
                        (service) =>
                          service === "RMapping" || service === "Admin",
                      ) !== undefined
                    ) {
                      handleUnMatchStatement(selectedCardIds);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "RMapping",
                        },
                      });
                    }
                  }
                } else {
                  if (
                    selectedCardIds?.length >
                    GlobalConfiguration.lengthCheckZero
                  ) {
                    if (
                      services?.find(
                        (service) =>
                          service === "AMapping" || service === "Admin",
                      ) !== undefined
                    ) {
                      handleMatchStatement(selectedCardIds);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "AMapping",
                        },
                      });
                    }
                  }
                }
              }}
              enabledBgColor={
                selectedCardIds?.length > GlobalConfiguration.lengthCheckZero
                  ? "var(--positive-act)"
                  : "var(--text-disabled)"
              }
              hoverOption={TEXT?.DARK}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              isDisabled={
                !selectedCardIds?.length > GlobalConfiguration.lengthCheckZero
              }
              disabledTextColor={""}
              isLoading={unmatchLoader || matchLoader ? true : false}
              disabledBgColor={""}
              fullWidthRequired={true}
              isbottomSectionneed={
                remType === "remitterUnmatch" || remType === "remitterMatch"
              }
              bottomHeaderTextNeed={true}
              confirmbtnrequired={
                remType === "remitterUnmatch" || remType === "remitterMatch"
              }
              inActiveVariantNeeded
              bottomHeaderText={
                remType === "remitterUnmatch"
                  ? TEXT?.UNMATCH_SELECTED_TRANSACTION
                  : remType === "remitterMatch"
                    ? TEXT?.CLICK_MATCH_TRANSACTION
                    : TEXT?.CONFIRM_MATCH_TRANSACTION
              }
              btnText={
                remType === "remitterUnmatch"
                  ? TEXT?.UNMATCH
                  : remType === "remitterMatch"
                    ? TEXT?.MATCH
                    : TEXT?.CONFIRM
              }
              isfullViewrequired={remType === "remitterMatch" && true}
              fullviewbtnText={TEXT?.REGISTER_NEW_ACCOUNT}
              redirectHeader={TEXT?.REGISTER_NEW_ACCOUNT}
              smallPopupHeader={TEXT?.LEAVE_PAGE_WARNING_HEADER}
              fullviewhandleFunction={() => {
                navigate("/remitter_account_dashboard/create_remitter_account");
              }}
              redirectIcon={ICONS?.ADD_BUTTON_WHITE}
            >
              <RemitterAccountViewAll
                remid={
                  totalRemiAccount?.length > GlobalConfiguration.lengthCheckZero
                    ? totalRemiAccount?.[0]
                    : unmatchRemiId?.length >
                        GlobalConfiguration.lengthCheckZero
                      ? unmatchRemiId
                      : matchRemiId?.length >
                          GlobalConfiguration.lengthCheckZero
                        ? matchRemiId
                        : ""
                }
                type={"RemitterAcc"}
                remType={remType}
                remiAcoountId={remiAcoountId}
                onCardNavigate={
                  remType !== "remitterUnmatch" &&
                  remType !== "remitterMatch" &&
                  handleCardNavigate
                }
                handleConfirmBtnClick={(e) => {}}
                selectedCardIds={selectedCardIds}
                setSelectedCardIds={setSelectedCardIds}
                cardType={
                  remType === "remitterUnmatch" || remType === "remitterMatch"
                    ? "matchRemAcc"
                    : ""
                }
                bottomHeaderText={
                  remType === "remitterUnmatch"
                    ? TEXT?.CONFIRM_UNMATCH_TRANSACTION
                    : remType === "remitterMatch"
                      ? TEXT?.CONFIRM_MATCH_TRANSACTION
                      : TEXT?.CONFIRM_MATCH_TRANSACTION
                }
                createDisabled={false}
                showModalPopup={true}
                propType={"ownerStatement"}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}
      {showDescriptionPopup && (
        <div
          style={{ zIndex: "var(--z-index-max)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center bg-opacity-dark-opacity"
        >
          <SmallPopupWithInput
            headerTitle={TEXT?.DESCRIPTION}
            headerFontColor="text-primary"
            headerFontWeight="semibold"
            textSize="font-md"
            subtext={TEXT?.PROVIDE_CUSTOM_DESCRIPTION}
            inputIsFullWidth={true}
            inputBgColor="var(--primary-bg)"
            inputPlaceholder={TEXT?.DESCRIPTION}
            bulletPoints={[TEXT?.TRACKING_AND_RECONCILIATION_NOTE]}
            inputFgColor={
              description?.length
                ? "var(--text-primary)"
                : "var(--text-secondary)"
            }
            inputVariant={computeVariant(description, isFocused)}
            inputOnFocus={(e) => setIsFocused(true)}
            inputOnBlur={(e) => setIsFocused(false)}
            inputValue={description}
            inputFontKind="medium"
            inputOnInput={(e) => {
              const sanitizedValue = e.target.value
                .replace(/\s+/g, " ")
                .replace(/^\s/, "")
                .slice(0, 150);

              setDescription(sanitizedValue);
            }}
            btnOneText={TEXT?.CANCEL}
            btnOneBtnType={TEXT?.BUTTON}
            btnOneHandleFunction={() => {
              if (!ownerAllAccAddDescriptionLoading) {
                setShowDescriptionPopup(false);
                setDescription("");
                setCurrentDescription({});
              }
            }}
            btnOneEnabledBgColor="transparent"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={ownerAllAccAddDescriptionLoading}
            btnOneHoverOption={TEXT?.WHITE}
            btnTwoText={
              currentDescription?.description?.length
                ? TEXT?.CONFIRM
                : TEXT?.ADD
            }
            btnTwoBtnType={TEXT?.BUTTON}
            btnTwoHandleFunction={async () => {
              if (!ownerAllAccAddDescriptionLoading) {
                let response = await dispatch(
                  addStatementDescription({
                    id: currentDescription.acc_id,
                    statement_entry_id:
                      currentDescription.account_statement_entry_id,
                    description: description,
                  }),
                );

                if (response?.payload?.status) {
                  dispatch(
                    updateStatementData({
                      description,
                      account_statement_entry_id:
                        currentDescription.account_statement_entry_id,
                    }),
                  );
                }

                setCurrentDescription({});
                setShowDescriptionPopup(false);
                setDescription("");
                setIsEditDescription(false);
              }
            }}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              (!isEditDescription && !description?.length) ||
              description === currentDescription?.description
            }
            btnTwoIsLoading={ownerAllAccAddDescriptionLoading}
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption={TEXT?.BLACK}
            btnTwoInActiveVariantNeeded={true}
          />
        </div>
      )}

      {openMatchPopup && (
        <>
          <div style={{ zIndex: "var(--z-index-modal)" }}>
            <RemitAccountViewAllPopup
              id={remiAcoountId}
              propType={"ownerStatement"}
              type={"RemitterAcc"}
              headerTitle={TEXT?.MATCH_REMITTER_ACCOUNTS}
              headersubtext={TEXT?.ONLY_UNMATCHED_ACCOUNT_SELECTION_NOTE}
              closePopup={() => setOpenMatchPopup(false)}
              handleConfirmBtnClick={(e) => {
                handleMatchStatement(e);
              }}
              btnText={TEXT?.MATCH}
              cardType={"matchRemAcc"}
              bottomHeaderText={TEXT?.CLICK_MATCH_TRANSACTION}
              isfullViewrequired={true}
              fullviewbtnText={TEXT?.REGISTER_NEW_ACCOUNT}
              redirectHeader={TEXT?.REGISTER_NEW_ACCOUNT}
              smallPopupHeader={TEXT?.LEAVE_PAGE_WARNING_HEADER}
              fullviewhandleFunction={() => {
                navigate("/remitter_account_dashboard/create_remitter_account");
              }}
              redirectIcon={ICONS?.ADD_BUTTON_WHITE}
              createDisabled={false}
              showModalPopup={true}
            />
          </div>
        </>
      )}
      {showConfirmPopup && (
        <div
          style={{ zIndex: "var(--z-index-modal)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center bg-opacity-dark-opacity"
        >
          <SmallPopup
            headerTitle={TEXT?.UPLOAD_STATEMENT_PROMPT}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext={TEXT?.EXIT_FLOW_NOTE}
            btnOneText={TEXT?.CANCEL}
            btnOneBtnType={TEXT?.BUTTON}
            btnOneHandleFunction={() => setShowConfirmPopup(false)}
            btnOneEnabledBgColor="transparent"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption={TEXT?.WHITE}
            btnTwoText={TEXT?.PROCEED}
            btnTwoBtnType={TEXT?.BUTTON}
            btnTwoHandleFunction={() =>
              navigate("/owner_account_dashboard/upload_bulk_bank_statement", {
                state: {
                  ownerBankAccountNo: props?.ownerDetailData?.bank_acc_no,
                  ownerBankIFSC: props?.ownerDetailData?.ifsc_code,
                  ownerBankLogo: props?.ownerDetailData?.ifsc_code,
                  bank_name: props?.ownerDetailData?.bank_name,
                  ownerBankAccountName: props?.ownerDetailData?.bank_name,
                },
              })
            }
            btnTwoEnabledBgColor="var(--brand-feedback-positive-action)"
            btnTwoEnabledTextColor="var(--brand-content-text-default)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption={TEXT?.BLACK}
          />
        </div>
      )}
      {showOwnerDetailPopup && (
        <LargePopupRedirect
          headerTitle={TEXT?.OWNER_ACCOUNT_DETAILS}
          closeiconhandleFunction={() => setShowOwnerDetailPopup(false)}
        >
          <OwnerDetailsPage
            onClosed={() => setShowOwnerDetailPopup(false)}
            popType={"ownerStatement"}
            ownerDetailId={ownerDetailId}
          />
        </LargePopupRedirect>
      )}
      {showOwnerPopup && (
        <div
          style={{ zIndex: "var(--z-index-modal)" }}
          className="fixed top-top-base left-left-base w-width-full h-height-full bg-Primary-black bg-opacity-light-opacity"
        >
          <OwnerAccountPopUp
            setOpenOwner={() => {
              setaccountnumberstate(accountNumber);
              setShowOwnerPopup(false);
            }}
            onClosed={() => {
              setAccountNumber(accountnumberstate);
              setShowOwnerPopup(false);
            }}
            accountNumber={accountNumber}
            setAccountNumber={setAccountNumber}
            accountnumberstate={accountnumberstate}
            setaccountnumberstate={setaccountnumberstate}
            multiSelect={true}
            setDefaultAccountNumber={setDefaultAccountNumber}
            accountDefaultNumber={accountDefaultNumber}
            flow={"txnViewAll"}
            popType={"ownerStatement"}
          />
        </div>
      )}
      <div
        className={` bg-primary-bg flex flex-col ${
          props?.popType === "remitterBankStatement" && "h-full"
        }  overflow-hidden ${
          props?.popType === "ownerStatement" ||
          props?.popType === "remitterBankStatement"
            ? " flex-1"
            : "h-full-height"
        }`}
      >
        <div
          className={`hidden ${
            props?.popType === "ownerStatement" ||
            props?.popType === "remitterBankStatement"
              ? "hidden"
              : "Qsmd:block"
          } `}
          style={{
            minHeight:
              props?.popType === "ownerStatement" ||
              props?.popType === "remitterBankStatement"
                ? "var(--navbar-height)"
                : "var(--navbar-breadcrumb-height)",
            backgroundColor: "var(--primary-nav)",
            zIndex: "var(--z-index-header)",
          }}
        ></div>

        <div className=" shadow-box-shadow-bottom z-z-index-content">
          {" "}
          <StatementTopNavComponent
            loading={false}
            topNavCtaBtn1Props={
              matchButton
                ? {
                    btnText:
                      selectStatementRow?.length >
                      GlobalConfiguration.lengthCheckZero
                        ? TEXT?.CLEAR
                        : TEXT?.CANCEL,
                    btnType: TEXT?.BUTTON,
                    enabledBgColor: "var(--primary-nav-act)",
                    handleFunction: (e) => {
                      setUnMatchStatement("");
                      setMatchStatement("");

                      if (
                        selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero
                      ) {
                        setSelectStatementRow([]);
                      } else {
                        setFlowType("");
                        setRemType("");
                        setMatchButton(false);
                        setRemiAcoountId([]);
                        setMatchRemiId([]);
                        setTotalRemiAccount([]);
                        setSelectedCardIds([]);
                        setStatementTypeState("");
                        setSelectStatementType(false);
                        setSelectStatementRow([]);
                      }
                    },
                    enabledTextColor: "var(--text-primary)",
                    isDisabled: false,
                    hoverOption: TEXT?.WHITE,
                  }
                : undefined
            }
            downloadFileProps={
              !matchButton
                ? {
                    btnText: TEXT?.DOWNLOAD_STATEMENT,
                    dropdownOptions: ["XLSX", "CSV", "TSV", "PDF"],
                    icon: ICONS.DOWNLOAD_STATEMENT,
                    isDisabled:
                      props?.flow === "rejectStatementdetails"
                        ? true
                        : (type === TEXT?.REMITTER_DETAILS
                              ? getAssociatedConsolidatedData
                                  ?.owner_account_details?.[0]?.statement
                                  ?.length
                              : ownerAllAccStatementData
                                  ?.owner_account_details?.[0]?.statement
                                  ?.length) ===
                            GlobalConfiguration.lengthCheckZero
                          ? true
                          : !accountDefaultNumber.length ||
                            ownerAllAccStatementLoading ||
                            getAssociatedConsolidatedLoading,
                    handleFunction: (e) => {
                      if (props?.flow === "rejectStatementdetails") {
                        actionRestricted();
                      } else {
                        if (
                          ownerAllAccStatementData === null ||
                          ownerAllAccStatementData?.total_count ===
                            GlobalConfiguration.lengthCheckZero
                        ) {
                          e.stopPropagation();
                          return;
                        } else {
                          downloadStatement();
                        }
                      }
                    },
                    selectedOption: selectedType,
                    setSelectedOption: setSelectedType,
                  }
                : false
            }
            topNavCtaBtn2Props={
              matchButton
                ? {
                    btnText: matchCondition ? TEXT?.MATCH : TEXT?.CONFIRM,
                    isLoading: matchLoader,
                    isLoaderNeeded: true,
                    btnType: TEXT?.BUTTON,
                    enabledBgColor:
                      selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero && !matchCondition
                        ? "var(--text-primary)"
                        : matchCondition &&
                            selectStatementRow?.length >
                              GlobalConfiguration.lengthCheckZero
                          ? "var(--positive-act)"
                          : "var(--text-disabled)",
                    inActiveVariantNeeded: true,
                    handleFunction: (e) => {
                      if (hasMatchPermission) {
                        if (
                          selectStatementRow?.length >
                          GlobalConfiguration.lengthCheckZero
                        ) {
                          if (matchCondition) {
                            handleMatchStatement(matchId);
                          } else {
                            setShowRemiAccounts(true);
                            setRemType("remitterMatch");
                          }
                        }
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "AMapping",
                          },
                        });
                      }
                    },
                    enabledTextColor:
                      selectStatementRow?.length >
                        GlobalConfiguration.lengthCheckZero && !matchCondition
                        ? "var(--primary-bg)"
                        : matchCondition &&
                            selectStatementRow?.length >
                              GlobalConfiguration.lengthCheckZero
                          ? "var(--text-primary)"
                          : "var(--text-primary)",
                    isDisabled: !hasMatchPermission
                      ? true
                      : selectStatementRow?.length ===
                        GlobalConfiguration.lengthCheckZero,
                    hoverOption: TEXT?.BLACK,
                  }
                : false
            }
            BottomSubTextVaraint={"primary"}
            BottomHeader={
              matchButton ? (
                <>
                  Select transactions to match to
                  <span
                    className={`${remitterName ? "font-semibold" : "font-normal"} ml-margin-xs`}
                  >
                    {remitterName || TEXT?.REMITTER_ACCOUNTS?.toLowerCase()}
                  </span>
                  .
                </>
              ) : (
                `As on ${new Date()
                  .toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })
                  .replace(
                    /(\w{3}) (\d{4})/,
                    "$1, $2",
                  )} - Statement update depends on availability from the bank.`
              )
            }
            selectionText={`Transactions selected : ${totalSelectedCount}`}
            selectionBtnProps={{
              btnText: `Select up to ${pageSize}`,

              btnType: TEXT?.BUTTON,

              handleFunction: () => {
                if (matchLoader) {
                  return;
                } else {
                  const statements =
                    type === TEXT?.REMITTER_DETAILS ||
                    props?.flow === "rejectStatementdetails"
                      ? getAssociatedConsolidatedData?.statement
                      : ownerAllAccStatementData?.statement;

                  const visibleRows =
                    statements?.map((item, index) => ({
                      rowId:
                        item?.account_statement_entry_id ||
                        item?.id ||
                        `${currentPage}-${index}`,
                      statement: item,
                    })) || [];

                  if (shouldClearPreviousSelection) {
                    setSelectStatementRow(selectedBankStatement || []);

                    const additionalIds = Array.isArray(remiAcoountId)
                      ? remiAcoountId
                      : remiAcoountId
                        ? [remiAcoountId]
                        : [];

                    setMatchRemiId(additionalIds);

                    setSelectedCardIds(additionalIds);

                    return;
                  }
                  setSelectStatementRow((prev) => {
                    const selectableRows = visibleRows.filter(
                      ({ rowId }) => !selectedBankStatement?.includes(rowId),
                    );

                    const selectableRowIds = selectableRows.map(
                      ({ rowId }) => rowId,
                    );

                    const currentPageSelectedCount = selectableRowIds.filter(
                      (id) => prev.includes(id),
                    ).length;

                    const shouldClearAll =
                      selectableRowIds.length >
                        GlobalConfiguration?.lengthCheckZero &&
                      currentPageSelectedCount === selectableRowIds.length;

                    if (shouldClearAll) {
                      const additionalIds = Array.isArray(remiAcoountId)
                        ? remiAcoountId
                        : remiAcoountId
                          ? [remiAcoountId]
                          : [];

                      setMatchRemiId(additionalIds);
                      setSelectedCardIds(additionalIds);

                      return [];
                    }

                    const protectedRows = prev.filter((id) =>
                      selectedBankStatement?.includes(id),
                    );

                    const rowsToSelect = selectableRowIds
                      .filter((id) => !prev.includes(id))
                      .slice(0, remainingSelection);

                    const updatedRows = [
                      ...new Set([
                        ...protectedRows,
                        ...prev.filter(
                          (id) => !selectedBankStatement?.includes(id),
                        ),
                        ...rowsToSelect,
                      ]),
                    ];

                    return updatedRows;
                  });

                  setSelectedCardIds(
                    Array.isArray(remiAcoountId)
                      ? remiAcoountId
                      : remiAcoountId
                        ? [remiAcoountId]
                        : [],
                  );
                }
              },

              enabledBgColor:
                isAllVisibleSelected && !loading && !ownerAllAccStatementLoading
                  ? "var(--positive-bg)"
                  : "var(--primary-nav-act)",

              hoverOption: isAllVisibleSelected ? TEXT?.BLACK : TEXT?.WHITE,

              enabledTextColor: "var(--text-primary)",

              isDisabled:
                getAssociatedConsolidatedLoading ||
                ownerAllAccStatementLoading ||
                loading ||
                matchLoader,

              icon:
                isAllVisibleSelected &&
                !loading &&
                !ownerAllAccStatementLoading &&
                !getAssociatedConsolidatedLoading
                  ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                  : ICONS.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
            }}
            iconRoundProps={
              !matchButton
                ? {
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: false,
                    handleFunction: (e) => {
                      if (props?.flow === "rejectStatementdetails") {
                        actionRestricted();
                      } else {
                        setShowConfirmPopup(true);
                      }
                    },
                    isDisabled:
                      props?.flow === "rejectStatementdetails" ? true : false,
                    icon: ICONS.UPLOAD,
                    title: TEXT?.UPLOAD_STATEMENT,
                    hoverOption: TEXT?.WHITE,
                  }
                : undefined
            }
            matchRemitterProps={
              !matchButton && props?.flow !== "rejectStatementdetails"
                ? {
                    handleFunction: () => {
                      if (
                        props?.flow === "rejectStatementdetails" ||
                        props?.flow === "ownerDetail"
                      ) {
                        actionRestricted();
                      } else {
                        if (hasMatchPermission) {
                          if (
                            !accountDefaultNumber.length ||
                            ownerAllAccStatementLoading
                          ) {
                            return;
                          } else {
                            setMatchButton(!matchButton);
                            setStatementTypeState("Credit");
                          }
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AMapping",
                            },
                          });
                        }
                      }
                    },
                    isDisabled: !hasMatchPermission
                      ? true
                      : props?.flow === "rejectStatementdetails" ||
                          props?.flow === "ownerDetail"
                        ? true
                        : props?.popType
                          ? true
                          : !accountDefaultNumber.length ||
                            ownerAllAccStatementLoading,
                    enabledBgColor: "var(--primary-bg)",
                    isLoading: false,
                    imgColor: "var(--text-primary)",
                    hoverOption: TEXT?.WHITE,
                    buttonRef: null,
                    title: TEXT?.IDENTIFY_SOURCE_CREDIT,
                  }
                : undefined
            }
            isSelectionView={matchButton ? true : false}
            filteredSearchProps={{
              isFilterDisabled:
                props?.statement_entry_id || !accountNumber.length,
              isColumnDisabled: props?.statement_entry_id
                ? true
                : !accountDefaultNumber.length,
              setShowInnerSearchBar: setShowInnerSearchBar,
              isSearchDisabled:
                props?.statement_entry_id || !accountNumber.length,

              onSearchInput: handleSearch,
              searchText: searchUserTextDebounce,
              searchPlaceholder: "Search consolidated bank statement",
              columnOptions: [
                { colName: "Bank", colWidth: "column-width-sm", flex: 0 },

                {
                  colName: "Transaction date and time",
                  colWidth: "column-width-lg",
                  flex: 1,
                },

                {
                  colName: "Value date",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Bank reference number",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Narration",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Type",
                  colWidth: "column-width-sm",
                  flex: 0,
                },

                {
                  colName: "Amount",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Debit amount",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Credit amount",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Closing balance",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Account number",
                  colWidth: "column-width-lg",
                  flex: 1,
                },

                {
                  colName: "IFSC",
                  colWidth: "column-width-md",
                  flex: 0,
                },

                {
                  colName: "Statement source",
                  colWidth: "column-width-lg",
                  flex: 0,
                },
                {
                  colName: "Name",
                  colWidth: "column-width-md",
                  flex: 0,
                },
                {
                  colName: "Description",
                  colWidth: "column-width-lg",
                  flex: 1,
                },

                {
                  colName: "Remitter account",
                  colWidth: "column-width-md",
                  flex: 0,
                },
              ],

              filterItems: [
                {
                  name: TEXT?.DEBIT_AMOUNT,
                  isMulti: false,
                  short_name: "Dr. Amt. -",
                  value: formatAmount(debiteAmount),
                  setValue: (val) => {
                    setDebitAmount(val);
                  },
                  isDropdown: false,
                  isDisabled: matchButton
                    ? true
                    : creditAmount !== ""
                      ? true
                      : props?.popType === "ownerStatement" ||
                          props?.flow === "rejectStatementdetails"
                        ? true
                        : false,
                },
                {
                  name: TEXT?.CREDIT_AMOUNT,
                  short_name: "Cr. Amt. -",
                  isMulti: false,
                  value: formatAmount(creditAmount),
                  setValue: (val) => {
                    setCreditAmount(val);
                  },
                  isDropdown: false,
                  isDisabled: debiteAmount !== "" ? true : false,
                  valueType: "string",
                },
              ],

              columnValue: additionalDetailColState,
              columnHandleChange: (val) => {
                handleAddDetail(val ? val : defaultAdditionalDetailCol);
              },
              isColumnDefaultDisabled:
                JSON.stringify(defaultAdditionalDetailCol) ===
                  JSON.stringify(additionalDetailColState) ||
                JSON.stringify(defaultAdditionalDetailCol) ===
                  JSON.stringify(additionalDetailColState),
              handleColumnDefault: () => {
                setAdditionalDetailsColState(defaultAdditionalDetailCol);
              },

              filters: [
                {
                  name: globalTextFormat(TEXT?.OWNER_ACCOUNT, [0]),
                  filterType: "accountSelect",
                  btnProps: {
                    btnText: accountnumberstate.length
                      ? `${accountnumberstate.length} selected`
                      : TEXT?.SELECT_ACCOUNTS,
                    enabledTextColor: "var(--text-primary)",
                    enabledBgColor: "var(--primary-nav-act)",
                    isDisabled:
                      props?.flow === "rejectStatementdetails" ||
                      props?.flow === "ownerDetail"
                        ? true
                        : false,
                    handleFunction: () => {
                      if (
                        props?.popType !== "ownerStatement" &&
                        props?.flow !== "ownerDetail"
                      ) {
                        if (props?.flow !== "rejectStatementdetails") {
                          setShowOwnerPopup(true);
                        }
                      }
                    },
                  },
                },

                {
                  name: TEXT?.AMOUNT_RANGE,
                  filterType: "amountRange",
                  variant: TEXT?.SINGLE,
                  size: TEXT?.SMALL,
                  value: isAmtFilterApplied,
                  rangeValue: amountRangeFilter,
                  setShowAmtFilterDiv: setShowAmtFilterDiv,
                  setIsAmtFilterApplied: setIsAmtFilterApplied,
                  handleChange: (val) => {
                    if (typeof val === "function") {
                      setAmountRangeFilter((prev) => val(prev));
                      return;
                    }

                    if (val && typeof val === "object") {
                      const nextMin = val?.min ?? "";
                      const nextMax = val?.max ?? "";
                      setAmountRangeFilter({
                        min: nextMin,
                        max: nextMax,
                      });
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("min_amount", nextMin);
                      handleSubmit("max_amount", nextMax);
                      return;
                    }

                    setAmountRangeFilter({ min: "", max: "" });
                    setCurrentPage(GlobalConfiguration.lengthCheckOne);
                    handleSubmit("min_amount", "");
                    handleSubmit("max_amount", "");
                  },
                },

                {
                  name: TEXT?.STATEMENT_SOURCE,
                  filterType: TEXT?.DROPDOWN,
                  variant: TEXT?.SINGLE,
                  options: ["Uploaded manually", "Fetch from bank"],
                  size: TEXT?.SMALL,
                  value: sourceState,
                  dropdownPlaceHolder: TEXT?.SELECT_SOURCE,
                  isDisabled: props?.flow === "rejectStatementdetails",

                  statusPop: true,
                  handleChange: (value) => {
                    if (props?.flow !== "rejectStatementdetails") {
                      setSourceState(value);
                    }
                  },
                },

                {
                  name: TEXT?.TRANSACTION_TYPE,
                  filterType: TEXT?.DROPDOWN,
                  variant: TEXT?.SINGLE,
                  options: ["Credit", "Debit"],
                  size: TEXT?.SMALL,
                  value: statementTypeState,
                  dropdownPlaceHolder: TEXT?.SELECT_TYPE,
                  isDisabled:
                    matchButton || props?.flow === "rejectStatementdetails"
                      ? true
                      : false,

                  statusPop: true,
                  handleChange: (value) => {
                    if (
                      !matchButton &&
                      props?.flow !== "rejectStatementdetails"
                    ) {
                      setStatementTypeState(value);
                    }
                  },
                },
                {
                  name: TEXT?.DATE_RANGE,
                  filterType: TEXT?.CALENDER,
                  variant: TEXT?.RANGE,
                  size: TEXT?.SMALL,
                  value: startDateState && endDateState,
                  isDisable: false,
                  startDate: startDateState
                    ? new Date(
                        startDateState * IntervalConfiguration.intervalMedium,
                      )
                    : startDateState,

                  endDate: endDateState
                    ? new Date(
                        endDateState * IntervalConfiguration.intervalMedium,
                      )
                    : endDateState,
                  maxDate: calenderMaxDate,
                  handleChange: (date) => {
                    setIsDateConfirm(date ? true : false);

                    handleDateChange(date);
                  },
                },
                {
                  name: TEXT?.MATCH_STATUS,
                  filterType: TEXT?.DROPDOWN,
                  variant: TEXT?.SINGLE,
                  options: ["Matched", "Unmatched"],
                  size: TEXT?.SMALL,
                  value: matchStatement || unmatchStatement,
                  dropdownPlaceHolder: TEXT?.SELECT_STATUS,
                  isDisabled: props?.flow === "rejectStatementdetails",

                  statusPop: true,
                  handleChange: (value) => {
                    if (value === TEXT?.MATCHED) {
                      setMatchStatement(value);
                      setUnMatchStatement("");
                    } else {
                      setUnMatchStatement(value);
                      setMatchStatement("");
                    }
                    move();
                  },
                },
              ],
              isFilterClearAllDisabled:
                props?.flow === "rejectStatementdetails"
                  ? !amountRangeFilter?.min &&
                    !amountRangeFilter?.max &&
                    !startDateState &&
                    !endDateState
                  : !matchStatement?.length &&
                    !unmatchStatement?.length &&
                    !sourceState?.length &&
                    !statementTypeState?.length &&
                    !debiteAmount?.length &&
                    !creditAmount?.length &&
                    !selectedtBankState?.length &&
                    !amountRangeFilter?.min &&
                    !amountRangeFilter?.max &&
                    !condition,

              isSearchClearAllDisabled: false,
              active: active,

              setActive: setActive,
              loading: ownerAllAccStatementLoading,
              setLoading: setLoadingData,
              isShowFilter: true,
              isShowColumn: true,
              loadingData: loadingData,
            }}
            openFilter={openDateFilter}
            setOpenFilter={setopenDateFilter}
            ispagination={
              (type === TEXT?.REMITTER_DETAILS ||
              props?.flow === "rejectStatementdetails"
                ? getAssociatedConsolidatedData?.statement?.length
                : ownerAllAccStatementData?.statement?.length) >
                GlobalConfiguration.lengthCheckZero && matchButton
            }
          />
        </div>

        <div
          ref={scrollRef}
          style={{
            scrollbarWidth: "none",
            overflowX: showInnerSearchBar
              ? "hidden"
              : type === TEXT?.REMITTER_DETAILS ||
                  props?.flow === "rejectStatementdetails"
                ? getAssociatedConsolidatedLoading ||
                  !getAssociatedConsolidatedData?.statement?.length
                  ? "hidden"
                  : "scroll"
                : ownerAllAccStatementLoading ||
                    !ownerAllAccStatementData?.statement?.length
                  ? "hidden"
                  : "scroll",
            marginBottom:
              getAssociatedConsolidatedLoading || ownerAllAccStatementLoading
                ? ""
                : props?.flow === "rejectStatementdetails" &&
                    getAssociatedConsolidatedData?.statement?.length ===
                      GlobalConfiguration.lengthCheckZero
                  ? ""
                  : (type === TEXT?.REMITTER_DETAILS ||
                      props?.flow === "rejectStatementdetails"
                        ? getAssociatedConsolidatedData?.statement?.length
                        : ownerAllAccStatementData?.statement?.length) >
                        GlobalConfiguration.lengthCheckZero &&
                      props?.flow !== "rejectStatementdetails"
                    ? "var(--pagination-height)"
                    : "",
            borderRadius: "inherit",
          }}
          className={`${
            props?.popType === "ownerStatement" ||
            props?.popType === "remitterBankStatement"
              ? "popupstatementviewallscrolls"
              : ""
          }  w-full overflow-y-hidden bg-primary-bg  ${showInnerSearchBar ? " overflow-x-hidden" : "overflow-x-auto"} flex  flex-col statementviewallscroll relative z-z-index-base flex-1`}
        >
          <div
            style={{
              display:
                !(type === TEXT?.REMITTER_DETAILS ||
                props?.flow === "rejectStatementdetails"
                  ? getAssociatedConsolidatedData?.statement?.length
                  : ownerAllAccStatementData?.statement?.length) ||
                getAssociatedConsolidatedLoading ||
                ownerAllAccStatementLoading
                  ? "none"
                  : "block",
              background: !ownerAllAccStatementData?.statement?.length
                ? "var(--primary-bg)"
                : !getAssociatedConsolidatedData?.statement?.length
                  ? "var(--primary-bg)"
                  : "var(--primary-nav)",
              zIndex: openMatchPopup
                ? "var(--z-index-base)"
                : showInnerSearchBar ||
                    showConfirmPopup ||
                    showDescriptionPopup ||
                    showOwnerPopup ||
                    showOwnerDetailPopup
                  ? "var(--z-index-base)"
                  : "var(--z-index-modal)",
              width:
                props?.popType === "ownerStatement" ||
                props?.popType === "remitterBankStatement"
                  ? "var(--popup-width)"
                  : "var(--width-full)",
              bottom:
                (props?.popType === "ownerStatement" ||
                  props?.popType === "remitterBankStatement") &&
                props?.flow !== "rejectStatementdetails"
                  ? "var(--bottom-sm)"
                  : "var(--bottom-base)",
              borderRadius:
                props?.popType === "ownerStatement" ||
                props?.popType === "remitterBankStatement"
                  ? " var(--border-radius-md)"
                  : "none",
              position:
                props?.popType === "remitterBankStatement" &&
                props?.flow !== "ownerDetail" &&
                "absolute",
              pointerEvents: showInnerSearchBar && "none",
            }}
            className={` fixed w-width-full   ${
              props?.popType === "ownerStatement" ||
              props?.popType === "remitterBankStatement"
                ? ""
                : ""
            }`}
          >
            <div
              className={` ${
                showInnerSearchBar &&
                " absolute opacity-light-opacity w-full h-full z-z-index-header bg-PopUp-BackDrop pointer-events-none "
              }`}
            ></div>{" "}
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={
                ownerAllAccStatementData || getAssociatedConsolidatedData || []
              }
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              setIsOpen={setIsOpen}
              typePopup={
                props?.popType === "ownerStatement" ||
                props?.flow === "ownerDetail"
                  ? true
                  : false
              }
            />
          </div>
          <div
            style={{
              marginBottom:
                props?.flow === "rejectStatementdetails" &&
                getAssociatedConsolidatedData?.total_count !==
                  GlobalConfiguration.lengthCheckZero &&
                "",
            }}
            className={`flex flex-1 ${
              showInnerSearchBar
                ? " pointer-events-none"
                : type === TEXT?.REMITTER_DETAILS ||
                    props?.flow === "rejectStatementdetails"
                  ? getAssociatedConsolidatedData?.statement?.length >
                    GlobalConfiguration.lengthCheckZero
                    ? "overflow-y-auto"
                    : ""
                  : ownerAllAccStatementData?.statement?.length >
                      GlobalConfiguration.lengthCheckZero
                    ? "overflow-y-auto"
                    : ""
            } flex-col`}
          >
            {showInnerSearchBar && (
              <>
                <div
                  className={`absolute top-top-base left-left-base h-full w-full overflow-x-hidden ${
                    ownerAllAccStatementLoading
                      ? "bg-PopUp-BackDrop opacity-dark-opacity"
                      : (type === TEXT?.REMITTER_DETAILS ||
                          props?.flow === "rejectStatementdetails"
                            ? getAssociatedConsolidatedData?.statement?.length
                            : ownerAllAccStatementData?.statement?.length) >
                          GlobalConfiguration.lengthCheckZero
                        ? "bg-PopUp-BackDrop opacity-dark-opacity"
                        : "opacity-light-opacity"
                  } pointer-events-none z-z-index-header overflow-hidden`}
                ></div>
              </>
            )}
            <div className="w-max min-w-full shadow-box-shadow-top z-z-index-content ">
              <div className={`oas-table-div-container z-z-index-content`}>
                {matchButton && (
                  <>
                    {" "}
                    <div>
                      {" "}
                      <p
                        className={`text-font-xs px-padding-xl h-auto break-all py-padding-button-l border-r border-primary-bg text-text-secondary text-center`}
                      >
                        Select
                      </p>
                    </div>
                  </>
                )}

                {additionalDetailColState?.map((column, index) => {
                  return (
                    <>
                      <p
                        style={{
                          minWidth: `var(--${column.colWidth})`,
                          flex: `${column.flex}`,
                        }}
                        className={`text-font-xs px-padding-md h-auto break-all py-padding-button-l text-text-secondary text-center`}
                      >
                        {column.colName}
                      </p>
                      <div
                        style={{
                          display:
                            index ===
                            additionalDetailColState.length -
                              GlobalConfiguration?.lengthCheckOne
                              ? "none"
                              : "block",
                        }}
                        className="oas-border-mid-div"
                      ></div>
                    </>
                  );
                })}
              </div>
            </div>

            {!accountNumber.length ? (
              <div className="h-height-full flex-col m-auto pb-padding-md  overflow-y-scroll justify-center items-center flex w-full">
                {showInnerSearchBar && (
                  <>
                    <div className="absolute top-top-base left-left-base h-full w-full overflow-x-hidden pointer-events-none bg-PopUp-BackDrop opacity-dark-opacity z-z-index-header overflow-hidden"></div>
                  </>
                )}
                <img
                  src={ICONS?.VIEW_CATEGORY_GRAPHICS}
                  alt={TEXT?.NO_ACCOUNTS_FOUND_NOTE}
                  className="w-graphic-width-sm Qsmd:w-graphic-width-md  h-graphic-square-height-sm Qsmd:h-graphic-square-height-md"
                />
                <p className="text-font-sm text-text-primary flex flex-col pt-padding-sm">
                  <span>
                    Select the accounts to view consolidated statement.
                  </span>
                </p>
                <div className="pt-padding-sm">
                  <PrimaryButton
                    enabledBgColor="var(--primary-act)"
                    btnText={TEXT?.SELECT_ACCOUNTS}
                    enabledTextColor="var(--text-primary)"
                    handleFunction={() => {
                      setShowOwnerPopup(true);
                    }}
                    buttonRef={selectAccountRef}
                    hoverOption={TEXT?.WHITE}
                  />
                </div>
              </div>
            ) : getAssociatedConsolidatedLoading ||
              ownerAllAccStatementLoading ? (
              <div
                className={`absolute top-auto overflow-hidden flex h-full m-auto justify-center items-center ${
                  props?.popType === "ownerStatement"
                    ? "w-full-popup-width"
                    : "w-full-width"
                }`}
              >
                <img
                  src={ICONS?.LOADER_GIF}
                  className="h-loader-lg w-loader-lg flex-shrink-0"
                  alt=""
                />
              </div>
            ) : ownerAllAccStatementData?.total_count >
                GlobalConfiguration.lengthCheckZero ||
              (getAssociatedConsolidatedData?.statement?.length &&
                flowType !== "remitter_details_match_statement" &&
                selectStatementType !== "remitter_edit_match_statement") ? (
              <div
                ref={scrollTopRef}
                style={{
                  flex: "1",
                  overflowY: showInnerSearchBar
                    ? "hidden"
                    : type === TEXT?.REMITTER_DETAILS ||
                        props?.flow === "rejectStatementdetails"
                      ? getAssociatedConsolidatedLoading ||
                        getAssociatedConsolidatedData?.owner_account_details
                          ?.statement?.length
                      : ownerAllAccStatementLoading ||
                          ownerAllAccStatementData?.owner_account_details
                            ?.statement?.length
                        ? "hidden"
                        : "auto",
                }}
                className={`flex flex-col  ${showInnerSearchBar ? " overflow-y-hidden" : "overflow-y-scroll"} w-max min-w-full relative ${matchButton && "mb-margin-xl Qsmd:mb-margin-base pb-padding-md Qsmd:pb-padding-base"}  mt-margin-base`}
              >
                <div className={`flex flex-col relative `}>
                  {showInnerSearchBar && (
                    <>
                      <div className="absolute top-top-base left-left-base h-full w-full overflow-x-hidden pointer-events-none  opacity-dark-opacity z-z-index-header overflow-hidden"></div>
                    </>
                  )}
                  {(type === TEXT?.REMITTER_DETAILS ||
                  props?.flow === "rejectStatementdetails"
                    ? getAssociatedConsolidatedData?.statement
                    : ownerAllAccStatementData?.statement
                  )?.map((statement, index) => {
                    const rowId =
                      statement?.account_statement_entry_id ||
                      statement?.id ||
                      `${currentPage}-${index}`;

                    const isPreSelected = selectedBankStatement.includes(rowId);
                    const isSelected =
                      isPreSelected || selectStatementRow.includes(rowId);

                    return (
                      <div
                        onClick={() => {
                          if (!matchButton) return;

                          if (isPreSelected) {
                            CommonToast({
                              text: TEXT?.UNMATCHING_TRANSACTION_RESTRICTED,
                              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                              variant: "var(--error)",
                            });
                            return;
                          }

                          const additionalIds = Array.isArray(remiAcoountId)
                            ? remiAcoountId
                            : remiAcoountId
                              ? [remiAcoountId]
                              : [];

                          const isSelected = selectStatementRow.includes(rowId);

                          const currentSelectedCount =
                            selectStatementRow.filter(
                              (id) => !selectedBankStatement?.includes(id),
                            ).length;

                          const maxLimit = Number(pageSize);

                          if (!isSelected && currentSelectedCount >= maxLimit) {
                            CommonToast({
                              text: TEXT?.MAXIMUM_LIMIT_REACHED,
                              icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
                              variant: "var(--error)",
                              buttonNeeded: false,
                            });

                            return;
                          }

                          setSelectStatementRow((prev) =>
                            isSelected
                              ? prev.filter((id) => id !== rowId)
                              : [...prev, rowId],
                          );

                          setSelectedCardIds(
                            Array.isArray(remiAcoountId)
                              ? remiAcoountId
                              : [remiAcoountId],
                          );
                        }}
                        className={` oas-table-div-content     ${
                          matchLoader
                            ? "cursor-default opacity-light-opacity"
                            : matchButton && !isPreSelected
                              ? "cursor-pointer"
                              : "cursor-default"
                        }  ${
                          isSelected && matchButton
                            ? "bg-positive-bg  z-z-index-content"
                            : isSelected
                              ? "global-hover-black"
                              : matchButton
                                ? "global-hover-white"
                                : ""
                        }   ${isPreSelected && matchButton && "opacity-light-opacity"}`}
                      >
                        {matchButton && (
                          <>
                            {" "}
                            <div className="px-padding-xl flex items-center justify-center">
                              <img
                                src={
                                  isSelected
                                    ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                    : ICONS.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE
                                }
                                alt="selection"
                                className="h-icon-sm ml-margin-sm"
                              />
                            </div>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === TEXT?.BANK,
                        ) && (
                          <>
                            <div className="text-font-xs flex-0 pr-padding-md pl-padding-lg h-auto py-padding-xs  text-text-secondary text-center min-w-column-width-sm w-column-width-sm flex items-center">
                              <div className="py-padding-button-s px-padding-sm rounded-border-radius-md bg-text-primary flex justify-center items-center">
                                <div className="w-banklogo-width-sm h-banklogo-height-sm flex-shrink-0">
                                  <IfscCodeMapper
                                    ifscCode={statement?.ifsc_code}
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === TEXT?.TRANSACTION_DATETIME,
                        ) && (
                          <>
                            <p
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              {formatDateandTime(
                                new Date(statement?.transaction_date),
                                true,
                              ) || "-"}
                            </p>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === TEXT?.VALUE_DATE,
                        ) && (
                          <>
                            <p
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              {formatDateandTime(
                                new Date(statement?.value_date),
                              ) || "-"}
                            </p>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === TEXT?.BANK_REFERENCE_NUMBER,
                        ) && (
                          <>
                            <p
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                              }
                            >
                              {statement?.bank_reference || "-"}
                            </p>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === TEXT?.NARRATION,
                        ) && (
                          <>
                            <p
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-1 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                              }
                            >
                              {linkIdentifier(statement?.narration) || "-"}
                            </p>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === TEXT?.TYPE,
                        ) && (
                          <>
                            <div
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              {statement?.credit_debit || "-"}
                            </div>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === TEXT?.AMOUNT,
                        ) && (
                          <>
                            <div
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-end text-right py-padding-xs flex-0 text-text-primary  w-column-width-md min-w-column-width-md"
                              }
                            >
                              INR{" "}
                              <FormatAmount price={Number(statement?.amount)} />
                            </div>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === TEXT?.DEBIT_AMOUNT,
                        ) && (
                          <>
                            <div
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-end py-padding-xs flex-0 text-failed text-right w-column-width-md min-w-column-width-md"
                              }
                            >
                              {statement.credit_debit === TEXT?.DEBIT ? (
                                <>
                                  INR{" "}
                                  <FormatAmount
                                    price={Number(statement?.amount)}
                                  />
                                </>
                              ) : (
                                "-"
                              )}
                            </div>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === TEXT?.CREDIT_AMOUNT,
                        ) && (
                          <>
                            <div
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-end py-padding-xs flex-0 text-settled text-right w-column-width-md min-w-column-width-md"
                              }
                            >
                              {statement.credit_debit === TEXT?.CREDIT ? (
                                <>
                                  INR{" "}
                                  <FormatAmount
                                    price={Number(statement?.amount)}
                                  />
                                </>
                              ) : (
                                "-"
                              )}
                            </div>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === TEXT?.CLOSING_BALANCE,
                        ) && (
                          <>
                            <p
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-end py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              INR{" "}
                              <FormatAmount
                                price={Number(statement?.closing_balance)}
                              />
                            </p>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === TEXT?.ACCOUNT_NUMBER,
                        ) && (
                          <>
                            <p
                              onClick={(e) => {
                                e.stopPropagation();
                                if (
                                  props?.flow !== "rejectStatementdetails" &&
                                  props?.flow !== "ownerDetail"
                                ) {
                                  if (props?.popType !== "ownerStatement") {
                                    setOwnerDetailID(
                                      statement.owner_account_id,
                                    );
                                    setTimeout(() => {
                                      setShowOwnerDetailPopup(true);
                                    }, 500);
                                  }
                                } else {
                                  if (props?.flow !== "ownerDetail") {
                                    actionRestricted();
                                  }
                                }
                              }}
                              className={`text-font-xs px-padding-md h-auto break-all flex ${props?.flow === "rejectStatementdetails" && "opacity-light-opacity cursor-not-allowed "} items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md ${
                                props?.popType !== "ownerStatement" &&
                                props?.flow !== "ownerDetail"
                                  ? "ownerredirect"
                                  : ""
                              } `}
                            >
                              {formatAccountNumber(
                                statement?.owner_bank_account_number,
                              ) || "-"}
                            </p>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === TEXT?.NAME,
                        ) && (
                          <>
                            <p
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-end py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              {statement?.name}
                            </p>
                          </>
                        )}
                        {additionalDetailColState?.some(
                          (x) => x.colName === TEXT?.IFSC,
                        ) && (
                          <>
                            <p
                              className={
                                "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                              }
                            >
                              {statement?.ifsc_code || "-"}
                            </p>
                          </>
                        )}
                        {additionalDetailColState.some(
                          (x) => x.colName === TEXT?.STATEMENT_SOURCE,
                        ) && (
                          <p
                            className={
                              "text-font-xs px-padding-md h-auto break-all flex items-center justify-center py-padding-xs flex-0 text-text-primary text-center w-column-width-md min-w-column-width-md"
                            }
                          >
                            {statement?.uploaded
                              ? TEXT?.UPLOADED_MANUALLY
                              : TEXT?.FETCHED_FROM_BANK}
                          </p>
                        )}
                        {additionalDetailColState.some(
                          (x) => x.colName === TEXT?.DESCRIPTION,
                        ) && (
                          <div
                            className={
                              " px-padding-md h-auto flex items-center justify-center py-padding-xs flex-1 text-text-primary text-center w-column-width-lg min-w-column-width-lg"
                            }
                          >
                            {statement?.description?.length ? (
                              <div className="flex gap-x-gap-sm justify-center">
                                <p className="text-font-xs text-text-secondary break-all">
                                  {linkIdentifier(statement?.description)}
                                </p>
                                <div className="border-r-border h-auto border-primary-act"></div>
                                <img
                                  title="Edit"
                                  src={ICONS?.EDIT}
                                  alt="edit"
                                  className={`h-icon-sm w-icon-sm flex-shrink-0  ${props?.flow === "rejectStatementdetails" && "opacity-light-opacity cursor-not-allowed "} ${matchButton && "opacity-light-opacity "} my-auto ${
                                    !services?.includes("ADescription") &&
                                    !services?.includes("Admin")
                                      ? "cursor-not-allowed opacity-light-opacity"
                                      : ` ${matchButton ? "cursor-default" : "cursor-pointer"}`
                                  } `}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (
                                      props?.flow === "rejectStatementdetails"
                                    ) {
                                      actionRestricted();
                                    } else {
                                      if (!matchButton) {
                                        if (
                                          !services?.includes("ADescription") &&
                                          !services?.includes("Admin")
                                        ) {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService:
                                                "VAccountBalance,Admin",
                                            },
                                          });
                                        } else {
                                          setIsEditDescription(true);
                                          setDescription(
                                            statement?.description,
                                          );
                                          setCurrentDescription({
                                            acc_id: statement?.owner_account_id,

                                            description: statement?.description,
                                            account_statement_entry_id:
                                              statement?.account_statement_entry_id,
                                          });
                                          setShowDescriptionPopup(true);
                                        }
                                      }
                                    }
                                  }}
                                />
                              </div>
                            ) : (
                              <PrimaryWithIconButton
                                btnText={TEXT?.ADD_DESCRIPTION}
                                outLineColor={"var(--text-primary)"}
                                btnType={TEXT?.BUTTON}
                                enabledBgColor="transparent"
                                enabledTextColor="var(--text-primary)"
                                hoverOption={TEXT?.WHITE}
                                iconToBeAlign="left"
                                icon={ICONS?.ADD_BUTTON_WHITE}
                                imgColor="var(--text-primary)"
                                isDisabled={
                                  props?.flow === "rejectStatementdetails"
                                    ? true
                                    : matchButton
                                      ? true
                                      : !services?.includes("ADescription") &&
                                        !services?.includes("Admin")
                                }
                                handleFunction={(e) => {
                                  e.stopPropagation();
                                  if (
                                    props?.flow === "rejectStatementdetails"
                                  ) {
                                    actionRestricted();
                                  } else {
                                    if (!matchButton) {
                                      if (
                                        !services?.includes("ADescription") &&
                                        !services?.includes("Admin")
                                      ) {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService:
                                              "ADescription,Admin",
                                          },
                                        });
                                      } else {
                                        setShowDescriptionPopup(true);
                                        setCurrentDescription({
                                          acc_id: statement?.owner_account_id,

                                          description: statement?.description,
                                          account_statement_entry_id:
                                            statement?.account_statement_entry_id,
                                        });
                                      }
                                    }
                                  }
                                }}
                              />
                            )}
                          </div>
                        )}
                        {props?.flow !== "rejectStatementdetails" &&
                          additionalDetailColState.some(
                            (x) => x.colName === TEXT?.REMITTER_ACCOUNT,
                          ) && (
                            <div
                              className={`  h-auto flex items-center justify-center py-padding-xs flex-1 pr-padding-md Qsmd:pr-padding-base text-text-primary text-center w-column-width-lg min-w-column-width-lg `}
                            >
                              {statement?.remitter_accounts?.length ? (
                                <div className="flex gap-x-gap-xs w-full px-padding-md">
                                  <div className="w-full justify-between items-center flex">
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        if (hasViewPermission) {
                                          if (
                                            props?.flow ===
                                              "rejectStatementdetails" ||
                                            props?.flow === "ownerDetail"
                                          ) {
                                            actionRestricted();
                                          } else {
                                            setShowRemiAccounts(true);
                                            setTotalRemiAccount([
                                              statement?.remitter_accounts?.map(
                                                (itm) =>
                                                  itm.remitter_account_id,
                                              ),
                                            ]);
                                          }
                                        } else {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService: "REVAccount",
                                            },
                                          });
                                        }
                                      }}
                                      className={`text-font-sm text-pending  underline ${props?.flow === "rejectStatementdetails" || props?.flow === "ownerDetail" ? "opacity-light-opacity cursor-not-allowed " : !hasViewPermission ? "opacity-light-opacity cursor-not-allowed" : "cursor-pointer"} `}
                                    >
                                      {`${statement?.remitter_accounts?.length}
                                    matched`}
                                    </div>

                                    <div
                                      className={` rounded-border-radius-md ${matchButton ? "hidden" : "block"} cursor-pointer  `}
                                    >
                                      <SecondaryAnimatedButton
                                        handleFunction={(e) => {
                                          e.stopPropagation();
                                          if (
                                            props?.flow ===
                                              "rejectStatementdetails" ||
                                            props?.flow === "ownerDetail"
                                          ) {
                                            actionRestricted();
                                          } else {
                                            if (!matchButton) {
                                              if (hasUnMatchPermission) {
                                                setShowRemiAccounts(true);
                                                setRemType("remitterUnmatch");
                                                setSelectStatementRow([
                                                  statement?.account_statement_entry_id,
                                                ]);
                                                setUnmatchRemiId(
                                                  statement?.remitter_accounts?.map(
                                                    (itm) =>
                                                      itm.remitter_account_id,
                                                  ),
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "RMapping",
                                                    },
                                                  },
                                                );
                                              }
                                            }
                                          }
                                        }}
                                        isDisabled={
                                          props?.flow ===
                                            "rejectStatementdetails" ||
                                          props?.flow === "ownerDetail" ||
                                          !hasUnMatchPermission
                                        }
                                        enabledBgColor={"var(--primary-nav)"}
                                        disabledBgColor=""
                                        isLoading={false}
                                        icon={ICONS.UNMATCH}
                                        imgColor={"var(--text-primary)"}
                                        hoverOption={TEXT?.WHITE}
                                        buttonRef={buttonRef}
                                        title={
                                          TEXT?.UNMATCH_REMITTER_ACCOUNTS_TRANSACTION
                                        }
                                        text={TEXT?.UNMATCH}
                                      />
                                    </div>
                                  </div>

                                  <div
                                    className={` ${matchButton ? " hidden" : "flex"}`}
                                  >
                                    <div
                                      className={` rounded-border-radius-md  cursor-pointer ${matchButton ? "hidden" : "block"} flex  `}
                                    >
                                      <SecondaryAnimatedButton
                                        handleFunction={(e) => {
                                          e.stopPropagation();

                                          if (
                                            props?.flow ===
                                              "rejectStatementdetails" ||
                                            props?.flow === "ownerDetail"
                                          ) {
                                            actionRestricted();
                                          } else {
                                            if (!matchButton) {
                                              if (hasMatchPermission) {
                                                setShowRemiAccounts(true);
                                                setRemType("remitterMatch");
                                                setSelectStatementRow([
                                                  statement?.account_statement_entry_id,
                                                ]);

                                                setMatchRemiId([
                                                  ...(statement?.remitter_accounts?.map(
                                                    (itm) =>
                                                      itm.remitter_account_id,
                                                  ) || []),
                                                  ...(Array.isArray(
                                                    remiAcoountId,
                                                  )
                                                    ? remiAcoountId
                                                    : remiAcoountId
                                                      ? [remiAcoountId]
                                                      : []),
                                                ]);

                                                setSelectedCardIds(
                                                  Array.isArray(remiAcoountId)
                                                    ? remiAcoountId
                                                    : [remiAcoountId],
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "AMapping",
                                                    },
                                                  },
                                                );
                                              }
                                            }
                                          }
                                        }}
                                        isDisabled={
                                          props?.flow ===
                                            "rejectStatementdetails" ||
                                          props?.flow === "ownerDetail" ||
                                          !hasMatchPermission
                                        }
                                        enabledBgColor={"var(--primary-nav)"}
                                        disabledBgColor=""
                                        isLoading={false}
                                        icon={ICONS.MATCH}
                                        hoverOption={TEXT?.WHITE}
                                        buttonRef={buttonRef}
                                        title={
                                          TEXT?.MATCH_REMITTER_ACCOUNT_TO_TRANSACTION
                                        }
                                        text={TEXT?.MATCH}
                                        imgColor={"var(--text-primary)"}
                                      />
                                    </div>
                                  </div>
                                </div>
                              ) : statement?.credit_debit !== TEXT?.DEBIT ? (
                                <>
                                  <PrimaryWithIconButton
                                    btnText={TEXT?.MATCH_REMITTER_ACCOUNTS}
                                    outLineColor={"var(--text-primary)"}
                                    btnType="button"
                                    enabledBgColor="transparent"
                                    enabledTextColor="var(--text-primary)"
                                    hoverOption={TEXT?.WHITE}
                                    iconToBeAlign="left"
                                    icon={ICONS.MATCHED_WITH_CIRCLE}
                                    imgColor="var(--text-primary)"
                                    isDisabled={
                                      !hasMatchPermission
                                        ? true
                                        : props?.flow ===
                                              "rejectStatementdetails" ||
                                            props?.flow === "ownerDetail"
                                          ? true
                                          : matchButton
                                            ? true
                                            : false
                                    }
                                    handleFunction={(e) => {
                                      e.stopPropagation();
                                      if (
                                        props?.flow ===
                                          "rejectStatementdetails" ||
                                        props?.flow === "ownerDetail"
                                      ) {
                                        actionRestricted();
                                      } else {
                                        if (hasMatchPermission) {
                                          if (!matchButton) {
                                            setSelectStatementRow([
                                              statement?.account_statement_entry_id,
                                            ]);
                                            setOpenMatchPopup(true);
                                          }
                                        } else {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService: "AMapping",
                                            },
                                          });
                                        }
                                      }
                                    }}
                                  />
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div
                className={`flex-1 flex-col m-auto  ${
                  props?.popType === "ownerStatement"
                    ? "w-full-popup-width"
                    : "w-full-width"
                } ${ownerAllAccStatementData?.statement?.length || getAssociatedConsolidatedData?.statement?.length ? "pb-padding-xl" : "pb-padding-base"}  overflow-y-scroll justify-center items-center flex`}
              >
                {showInnerSearchBar && (
                  <>
                    <div className="absolute top-top-base left-left-base h-full w-full overflow-x-hidden pointer-events-none bg-PopUp-BackDrop opacity-dark-opacity z-z-index-header overflow-hidden"></div>
                  </>
                )}
                <img
                  src={ICONS?.NO_DATA_FOUND}
                  alt="No accounts found"
                  className="w-graphic-rectangle-height-md h-graphic-rectangle-height-md"
                />
                <p className="text-text-primary text-font-sm pt-padding-sm items-center">
                  No data found.
                </p>
                <div className="pt-padding-sm mt-margin-sm">
                  <PrimaryButton
                    isDisabled={false}
                    enabledBgColor="var(--primary-act)"
                    btnText={
                      condition
                        ? TEXT?.CLEAR_PARAMETERS
                        : TEXT?.CHANGE_DATE_RANGE
                    }
                    enabledTextColor="var(--text-primary)"
                    handleFunction={() => {
                      if (!condition) {
                        setopenDateFilter(true);
                        return;
                      }

                      move();
                      if (props?.flow === "rejectStatementdetails") {
                        setaccountnumberstate([]);
                        setStartDateState("");
                        setEndDateState("");
                      } else {
                        setaccountnumberstate(accountDefaultNumber);
                        setStartDateState(defaultStartDate);
                        setEndDateState(defaultEndDate);
                      }
                      setDebitAmount("");
                      setCreditAmount("");
                      setSelectedtBankState("");
                      setSourceState("");
                      setStatementTypeState("");
                      setSelectStatementRow([]);
                      setAmountRangeFilter({ min: "", max: "" });
                      setUnMatchStatement("");
                      setMatchStatement("");
                      setMatchButton("");
                      setIsAmtFilterApplied(false);
                      setIsDateConfirm(false);
                      setCurrentPage(1);
                    }}
                    buttonRef={selectAccountRef}
                    hoverOption={TEXT?.WHITE}
                  />
                </div>
              </div>
            )}
          </div>
          <div
            className={`${
              getAssociatedConsolidatedData?.total_count ===
                GlobalConfiguration.lengthCheckZero ||
              props?.flow !== "rejectStatementdetails" ||
              getAssociatedConsolidatedLoading ||
              ownerAllAccStatementLoading
                ? "hidden"
                : "block h-pagination-height"
            }`}
          ></div>
        </div>
      </div>
    </>
  );
};

export default OwnerAccountConsolidatedBankStatement;
